import { render, staticRenderFns } from "./ItemReturnReasons.vue?vue&type=template&id=6da96ab4&"
import script from "./ItemReturnReasons.vue?vue&type=script&lang=js&"
export * from "./ItemReturnReasons.vue?vue&type=script&lang=js&"
import style0 from "./ItemReturnReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports